import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MailIcon, LockIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
import KreditaLogo from '../components/KreditaLogo';
const LoginPage = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    if (errors[name]) {
      setErrors(prev => {
        const newErrors = {
          ...prev
        };
        delete newErrors[name];
        return newErrors;
      });
    }
  };
  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    if (!formData.email.trim()) newErrors.email = 'Email is required';else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email is invalid';
    if (!formData.password) newErrors.password = 'Password is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitting(true);
      setTimeout(() => {
        setIsSubmitting(false);
        navigate('/dashboard');
      }, 1000);
    }
  };
  return <div className="bg-gray-50 min-h-screen w-full flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-996">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-997">
        <div className="flex justify-center text-primary" data-id="element-998">
          <KreditaLogo data-id="element-999" />
        </div>
        <h2 className="mt-6 text-center text-3xl font-bold text-gray-900" data-id="element-1000">
          Welcome back
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600" data-id="element-1001">
          Don't have an account?{' '}
          <Link to="/register" className="font-medium text-primary hover:text-[rgb(var(--color-primary-dark))]" data-id="element-1002">
            Sign up
          </Link>
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-1003">
        <div className="bg-white py-8 px-4 shadow-lg sm:rounded-xl sm:px-10" data-id="element-1004">
          <form className="space-y-6" onSubmit={handleSubmit} data-id="element-1005">
            <div data-id="element-1006">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1007">
                Email address
              </label>
              <div className="relative" data-id="element-1008">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1009">
                  <MailIcon className="h-5 w-5 text-gray-400" data-id="element-1010" />
                </div>
                <input id="email" name="email" type="email" autoComplete="email" value={formData.email} onChange={handleChange} className={`block w-full pl-10 pr-3 py-2.5 border rounded-lg shadow-sm focus:ring-2 focus:ring-primary focus:border-transparent sm:text-sm ${errors.email ? 'border-red-500' : 'border-gray-300'}`} placeholder="you@example.com" data-id="element-1011" />
              </div>
              {errors.email && <p className="mt-2 text-sm text-red-600" data-id="element-1012">{errors.email}</p>}
            </div>

            <div data-id="element-1013">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1014">
                Password
              </label>
              <div className="relative" data-id="element-1015">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1016">
                  <LockIcon className="h-5 w-5 text-gray-400" data-id="element-1017" />
                </div>
                <input id="password" name="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" value={formData.password} onChange={handleChange} className={`block w-full pl-10 pr-10 py-2.5 border rounded-lg shadow-sm focus:ring-2 focus:ring-primary focus:border-transparent sm:text-sm ${errors.password ? 'border-red-500' : 'border-gray-300'}`} placeholder="••••••••" data-id="element-1018" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-1019">
                  {showPassword ? <EyeOffIcon className="h-5 w-5 text-gray-400 hover:text-gray-600" data-id="element-1020" /> : <EyeIcon className="h-5 w-5 text-gray-400 hover:text-gray-600" data-id="element-1021" />}
                </button>
              </div>
              {errors.password && <p className="mt-2 text-sm text-red-600" data-id="element-1022">{errors.password}</p>}
            </div>

            <div className="flex items-center justify-between" data-id="element-1023">
              <div className="flex items-center" data-id="element-1024">
                <input id="rememberMe" name="rememberMe" type="checkbox" checked={formData.rememberMe} onChange={handleChange} className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded" data-id="element-1025" />
                <label htmlFor="rememberMe" className="ml-2 block text-sm text-gray-900" data-id="element-1026">
                  Remember me
                </label>
              </div>

              <div className="text-sm" data-id="element-1027">
                <a href="#" className="font-medium text-primary hover:text-[rgb(var(--color-primary-dark))]" data-id="element-1028">
                  Forgot password?
                </a>
              </div>
            </div>

            <div data-id="element-1029">
              <button type="submit" disabled={isSubmitting} className={`w-full btn-primary ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`} data-id="element-1030">
                {isSubmitting ? 'Signing in...' : 'Sign in'}
              </button>
            </div>
          </form>

          <div className="mt-6" data-id="element-1031">
            <div className="relative" data-id="element-1032">
              <div className="absolute inset-0 flex items-center" data-id="element-1033">
                <div className="w-full border-t border-gray-300" data-id="element-1034" />
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-1035">
                <span className="px-2 bg-white text-gray-500" data-id="element-1036">
                  Or continue with
                </span>
              </div>
            </div>

            <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-1037">
              <button type="button" className="w-full inline-flex justify-center py-2.5 px-4 border border-gray-300 rounded-lg shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1038">
                <svg className="w-5 h-5" viewBox="0 0 24 24" data-id="element-1039">
                  <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-1040" />
                  <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-1041" />
                  <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-1042" />
                  <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-1043" />
                </svg>
              </button>

              <button type="button" className="w-full inline-flex justify-center py-2.5 px-4 border border-gray-300 rounded-lg shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1044">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-1045">
                  <path d="M12 2C6.477 2 2 6.477 2 12c0 4.42 2.865 8.17 6.839 9.49.5.092.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.603-3.369-1.34-3.369-1.34-.454-1.156-1.11-1.463-1.11-1.463-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.831.092-.646.35-1.086.636-1.336-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.578 9.578 0 0112 6.836c.85.004 1.705.114 2.504.336 1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.138 20.167 22 16.418 22 12c0-5.523-4.477-10-10-10z" data-id="element-1046" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default LoginPage;